import { RouteComponentProps } from '@reach/router';
import { AppPath } from 'appConstants';
import SignInForm from 'components/signInForm/SignInForm';
import { useDefaultRoute } from 'hooks/useDefaultRoute';
import React from 'react';
import Page from '../components/shared/Page';

export const SignIn: React.FC<RouteComponentProps> = () => {
  useDefaultRoute(AppPath.SIGN_IN);

  const getURLArea = new URLSearchParams(window.location.search).get('area');

  return (
    <Page isPublic redirectPath={getURLArea ? getURLArea : ''}>
      <div className="SignInPage">
        <div className="Content HeightContent">
          <SignInForm />
        </div>
      </div>
    </Page>
  );
};
